// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpansionPanel_wrapper__nJDB9","btn":"ExpansionPanel_btn__DuAXR","open":"ExpansionPanel_open__DPdHy"};